var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-btn"},[_c('button',{on:{"click":_vm.addToCart}},[_vm._v("Next")]),_c('div',{staticClass:"download pcShow",on:{"click":_vm.createPdf}},[_vm._v("Download"),_c('a-icon',{attrs:{"type":"cloud-download"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }